import type { PropsWithChildren } from 'react';

import { Center, Td, Tr } from '@frontend/components';

export type EmptyContentWrapperProps = PropsWithChildren<{
  numberOfColumns: number;
}>;

export const EmptyContentWrapper = ({
  numberOfColumns,
  children,
}: EmptyContentWrapperProps) => {
  return (
    <Tr>
      <Td colSpan={numberOfColumns} height="auto">
        <Center position="absolute" top={0} left={0} width="100%" height="100%">
          {children}
        </Center>
      </Td>
    </Tr>
  );
};
